<template>
  <div>
    <template v-for="(item, index) in items">
      <div
        class="divider"
        v-if="item.type === 'divider'"
        :key="`divider${index}`"
      />
      <menu-item v-else :key="index" v-bind="item" />
    </template>

    <v-dialog persistent v-model="addImageDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">Add Image</v-card-title>
        <v-card-text>
          <file-upload
            :media="'image'"
            :accept="accepted"
            label="upload"
            :src="docLink"
            :refName="'upload7098'"
            :role="'patient'"
            :multiple="false"
            :module="'referred'"
            :drop="true"
            @uploaded="fileUploaded"
            :uploadFileToServer="true"
            :uploadedImg="uploadedImg"
            @removeImage="deleteImg"
            :isBlogImage="true"
          ></file-upload>
          <span
            v-if="uploadedImgFullUrl.length === 0 && alert == true"
            class="text-danger required-fields"
          >
            {{ requiredAlert }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeModal()">Close</v-btn>
          <v-btn color="success" @click="addImg()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addLinkDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">Add Link</v-card-title>
        <v-card-text>
          <label for>Enter Url</label>
          <input
            v-model="link"
            type="text"
            placeholder="Enter Url"
            class="form-control"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeLinkModal()">Close</v-btn>
          <v-btn color="success" @click="setLink()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MenuItem from "./MenuItem.vue";
import FileUpload from "@/components/FileUpload.vue";
export default {
  components: {
    MenuItem,
    FileUpload,
  },

  props: {
    editor: {
      type: Object,
      required: true,
    },
    uploadType:{
      type: String,
      default: ""
    }
  },

  data() {
    return {
      items: [
        {
          icon: "bold",
          title: "Bold",
          action: () => this.editor.chain().focus().toggleBold().run(),
          isActive: () => this.editor.isActive("bold"),
        },
        {
          icon: "italic",
          title: "Italic",
          action: () => this.editor.chain().focus().toggleItalic().run(),
          isActive: () => this.editor.isActive("italic"),
        },
        {
          icon: "strikethrough",
          title: "Strike",
          action: () => this.editor.chain().focus().toggleStrike().run(),
          isActive: () => this.editor.isActive("strike"),
        },
        {
          icon: "code-view",
          title: "Code",
          action: () => this.editor.chain().focus().toggleCode().run(),
          isActive: () => this.editor.isActive("code"),
        },
        {
          icon: "mark-pen-line",
          title: "Highlight",
          action: () => this.editor.chain().focus().toggleHighlight().run(),
          isActive: () => this.editor.isActive("highlight"),
        },
        {
          type: "divider",
        },
        {
          icon: "h-1",
          title: "Heading 1",
          action: () =>
            this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
          isActive: () => this.editor.isActive("heading", { level: 1 }),
        },
        {
          icon: "h-2",
          title: "Heading 2",
          action: () =>
            this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
          isActive: () => this.editor.isActive("heading", { level: 2 }),
        },
        {
          icon: "paragraph",
          title: "Paragraph",
          action: () => this.editor.chain().focus().setParagraph().run(),
          isActive: () => this.editor.isActive("paragraph"),
        },
        {
          icon: "list-unordered",
          title: "Bullet List",
          action: () => this.editor.chain().focus().toggleBulletList().run(),
          isActive: () => this.editor.isActive("bulletList"),
        },
        {
          icon: "list-ordered",
          title: "Ordered List",
          action: () => this.editor.chain().focus().toggleOrderedList().run(),
          isActive: () => this.editor.isActive("orderedList"),
        },
        {
          icon: "list-check-2",
          title: "Task List",
          action: () => this.editor.chain().focus().toggleTaskList().run(),
          isActive: () => this.editor.isActive("taskList"),
        },
        {
          icon: "code-box-line",
          title: "Code Block",
          action: () => this.editor.chain().focus().toggleCodeBlock().run(),
          isActive: () => this.editor.isActive("codeBlock"),
        },
        {
          type: "divider",
        },
        {
          icon: "double-quotes-l",
          title: "Blockquote",
          action: () => this.editor.chain().focus().toggleBlockquote().run(),
          isActive: () => this.editor.isActive("blockquote"),
        },
        {
          icon: "separator",
          title: "Horizontal Rule",
          action: () => this.editor.chain().focus().setHorizontalRule().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "text-wrap",
          title: "Hard Break",
          action: () => this.editor.chain().focus().setHardBreak().run(),
        },
        {
          icon: "format-clear",
          title: "Clear Format",
          action: () =>
            this.editor.chain().focus().clearNodes().unsetAllMarks().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "arrow-go-back-line",
          title: "Undo",
          action: () => this.editor.chain().focus().undo().run(),
        },
        {
          icon: "arrow-go-forward-line",
          title: "Redo",
          action: () => this.editor.chain().focus().redo().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "image-add-line",
          title: "Add Image",
          action: () => this.openUploadDialog(),
        },
        {
          type: "divider",
        },
        {
          icon: "link-m",
          title: "Set Link",
          action: () => this.openlinkDialog(),
          isActive: () => this.editor.isActive("link"),
        },
        {
          icon: "link-unlink-m",
          title: "Unset Link",
          action: () => this.editor.chain().focus().unsetLink().run(),
        },
      ],
      addLinkDialog: false,
      link: "",
      addImageDialog: false,
      uploadedImg: [],
      uploadedImgFullUrl: [],
      accepted: "image/png,image/jpg,image/jpeg,application/pdf",
      docLink: null,
      alert: false,
      requiredAlert: "This field is required.",
    };
  },

  methods: {
    openlinkDialog() {
      const previousUrl = this.editor.getAttributes("link").href;
      this.link = previousUrl;
      this.addLinkDialog = true;
    },
    closeLinkModal() {
      this.addLinkDialog = false;
    },
    setLink() {
      const url = this.link;
      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor.chain().focus().extendMarkRange("link").unsetLink().run();

        return;
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();

      this.addLinkDialog = false;
    },
    openUploadDialog() {
      this.addImageDialog = true;
    },

    fileUploaded(files, uploaded, name) {
      if (uploaded) {
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map((el) => {
          return el.split("/").pop();
        });
      }
    },

    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
    },
    closeModal() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
      this.addImageDialog = false;
    },
    addImg() {
      if (this.uploadedImgFullUrl.length > 0) {
        if (this.uploadType == 'url') {
          this.$emit('uploadedFile', this.uploadedImgFullUrl[0])
          this.addImageDialog = false;
          this.deleteImg();
        } else {
          this.editor
            .chain()
            .focus()
            .setImage({
              src: this.uploadedImgFullUrl[0],
            })
            .run();
          this.closeModal();
        }
      } else {
        this.alert = true;
      }
    },
  },
};
</script>

<style lang="scss">
.divider {
  width: 2px;
  height: 1.25rem;
  background-color: rgba(#000, 0.1);
  margin-left: 0.5rem;
  margin-right: 0.75rem;
}
</style>